/**
 * This bug as of now it appears just with setup Candle Trigger, in which the user selects time unit MINUTES, and puts
 * the candlesBack field at greater than 1. Not so robust, probably adjust in future
 * 
 * {
	"messageType": "alertNotification",
	"notificationId": 1645468182786,
	"notificationDetails": {"errorType":"TACTIC_VALIDATION","notificationType":"ERROR","tacticName":"CANDLE_TRIGGER","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "CANDLES_BACK_GREATER_THAN_ONE",
	"statusDetails": {"candlesBack":1,"timeUnit":"MINUTES","tacticName":"CANDLE_TRIGGER","candleDuration":2},
	"date": "2022-02-21T13:29:43.701-0500",
	"timestamp": "1645468183701"
}

 * @param {} statusDetails 
 */
export function candlesBackGreaterThan1Parser(statusDetails) {
  const parsedObj = {
    candlesBack: null,
    timeUnit: null,
    tacticName: null,
    candleDuration: null,
  };
  if (statusDetails) {
    parsedObj.candlesBack = statusDetails.candlesBack ?? null;
    parsedObj.timeUnit = statusDetails.timeUnit ?? null;
    parsedObj.tacticName = statusDetails.tacticName ?? null;
    parsedObj.candleDuration = statusDetails.candleDuration ?? null;
  }

  return parsedObj;
}
